import { commitMutation, graphql } from 'react-relay';

import environment from 'src/util/environment';

const mutation = graphql`
  mutation InviteCustomerUserMutation($input: InviteCustomerUserInput!) {
    inviteCustomerUser(input: $input) {
      id
      uuid
      externalIdentifier
      type
      email
      givenName
      familyName
      active { start finish }
      createdAt
      updatedAt
    }
  }
`;

const InviteCustomerUserMutation = (input, onCompleted, onError) => {
  const variables = { input };

  commitMutation(
    environment,
    {
      mutation,
      variables,
      onCompleted,
      onError,
    },
  );
};

export default InviteCustomerUserMutation;
